import { useAuth } from "../context/AuthProvider";
import useStore from "../store/store";
import { hasAllPermissions, hasRole } from "../helpers/accessHelper";

export const PermissionWrapper = ({ permissions = [], children, fallback = null }) => {
  const { user: authUser, isHydrated } = useAuth();
  const storeUser = useStore((state) => state.user);
  
  const user = authUser || storeUser;

  if (!isHydrated) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  if (!user) return null;

  return hasAllPermissions(user, permissions) ? children : fallback;
};

export const RoleWrapper = ({ roles = [], children, fallback = null  }) => {
  const { user: authUser, isHydrated } = useAuth();
  const storeUser = useStore((state) => state.user);

  const user = authUser || storeUser;

  if (!isHydrated) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  if (!user) return null;

  return hasRole(user, roles) ? children : fallback;
};
